module.exports = __webpack_public_path__ + "media/our_mission/Robin-b3dc46bf.webp";